var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewDelet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1628_3280",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 19
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.266602,
    y: 0.366211,
    width: 18.2099,
    height: 18.2099,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1628_3280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.578 16.3C5.16069 16.3 4.80344 16.1514 4.50627 15.8542C4.20909 15.5571 4.0605 15.1998 4.0605 14.7825V4.91882H3.30176V3.40132H7.09549V2.64258H11.648V3.40132H15.4417V4.91882H14.6829V14.7825C14.6829 15.1998 14.5344 15.5571 14.2372 15.8542C13.94 16.1514 13.5828 16.3 13.1655 16.3H5.578ZM13.1655 4.91882H5.578V14.7825H13.1655V4.91882ZM7.09549 13.265H8.61298V6.43631H7.09549V13.265ZM10.1305 13.265H11.648V6.43631H10.1305V13.265Z",
    fill: "#FF1212"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewDelet);
export default __webpack_public_path__ + "static/media/newDelet.aa7c4b978aa3b707844e79a4d6364d42.svg";
export { ForwardRef as ReactComponent };